// extracted by mini-css-extract-plugin
export default {"SearchBar":"SearchBar_SearchBar__MQiwu"};